import React, { useEffect } from 'react';
import { useOptionalTheme } from './ThemeController.jsx';

/** Supply only the server-selected profile ID and its persistence adapter to the display controller.
 * Theme cannot select an actor, restore a session or change any authority. */
export default function ProfileThemeBinding({ profileId, store, children }) {
  const configure = useOptionalTheme()?.configureProfile;
  useEffect(() => {
    configure?.({ profileId, store });
    return () => configure?.(null);
  }, [profileId, store, configure]);
  return <>{children}</>;
}
